// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"zS","imageWrapper":"zT","image":"zU","copyrightAndBrandLogo":"zV","brandLogo":"zW","copyright":"zX","rentalBadge":"zY"};